module.exports = __webpack_public_path__ + "static/media/artwork.350c0f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/artwork.png
// module id = 60
// module chunks = 0